import CSQCAxios from '@/outils/CSQCAxios';

const CONTROLLER_NAME = 'Paiement';

export default {
  clearCache: false,
  definirEleveEcoleGuid(eleveId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/Eleve/${eleveId}/EleveEcoleGUID`);
  },
  eleveDefinirCours(eleveId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/Eleve/${eleveId}/Cours`);
  },
  eleveDefinirCoursEleve(eleveId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/Eleve/${eleveId}/CoursEleve`);
  },
  effectuerRemboursementPartiel(coursEleveId, montantRemboursementPartiel, provenance) {
    let route = `${CONTROLLER_NAME}/CoursEleve/${coursEleveId}/RemboursementPartiel`;
    const params = [];
    if (montantRemboursementPartiel || montantRemboursementPartiel === 0) {
      params.push(`montantRemboursement=${montantRemboursementPartiel}`);
    }
    if (provenance || montantRemboursementPartiel === 0) {
      params.push(`provenanceEleve=${provenance}`);
    }
    if (params.length > 0) {
      route += `?${params.join('&')}`;
    }
    return CSQCAxios.getAxios().get(route);
  },
  definirIdEleveSelonGuid(guidPageConfirmation) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/${guidPageConfirmation}/EleveId`);
  },
  retirerEtatListeAttente(factureId) {
    // Changement d'état après le paiement d'un cours
    return CSQCAxios.getAxios().put(`${CONTROLLER_NAME}/Facture/${factureId}/RetirerEtatListeAttente`);
  },
  obtenirBlocsSelonId(blocsId) {
    return CSQCAxios.getAxios().put(`${CONTROLLER_NAME}/BlocsSelonId`, blocsId);
  },
  ObtenirTransactionsSelonCoursEleveId(listeCoursEleveId) {
    return CSQCAxios.getAxios().put(`${CONTROLLER_NAME}/TransactionsSelonCoursEleveId`, listeCoursEleveId);
  },
  definirPlaceDansListeAttenteSelonCoursCourant(listeCoursEleve, anneeScolaire) {
    return CSQCAxios.getAxios().put(`${CONTROLLER_NAME}/PlaceDansListeAttente?anneeScolaire=${anneeScolaire}`, listeCoursEleve);
  },
  verifierSiPeutPayer(coursEleveId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/CoursEleve/${coursEleveId}/VerifierSiPeutPayer`);
  },
  definirCoursIdSelonCoursEleveId(coursEleveId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/CoursEleve/${coursEleveId}/CoursId`);
  },
  verifierCoursEstDejaAchete(coursEleveId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/CoursEleve/${coursEleveId}/VerifierCoursEstDejaAchete`);
  },
  obtenirEleve(eleveId) {
    return CSQCAxios.getAxios().get(`${CONTROLLER_NAME}/Eleve/${eleveId}`);
  },
};
